/**
 * since in dev-mode the env file is not loaded (fetch-schema-script.js)
 * we have to go the extra mile...
 */

const DEVCONSTANTS = {
  LOCAL: {
    API: 'http://localhost:5000/api/v1',
  },

  STAGING: {
    API: '/api/v1', // backend is mapped to /api inside the deployment
  },

  PRODUCTION: {
    API: '/api/v1', // backend is mapped to /api inside the deployment
  },

  MODES: {
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    LOCAL: 'LOCAL',
  },
}

// only change this for your DEV MODE
const MODE = DEVCONSTANTS.MODES.PRODUCTION

module.exports = {
  API_URL: DEVCONSTANTS[MODE].API,
}
